import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "app"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, "AI肉質評価システム (AI-MEAT)", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImpersonationBanner = _resolveComponent("ImpersonationBanner")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_base_footer = _resolveComponent("base-footer")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createBlock(_component_el_config_provider, { locale: _ctx.locale }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.auth.isAuthenticated)
          ? (_openBlock(), _createBlock(_component_ImpersonationBanner, { key: 0 }))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_el_menu, {
          class: "header-menu",
          mode: "horizontal",
          onSelect: _ctx.handleMenuSelect,
          "default-active": _ctx.currentMenuIndex
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createVNode(_component_el_menu_item, { index: "1" }, {
              default: _withCtx(() => [
                _createTextVNode("BMS推定")
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "2" }, {
              default: _withCtx(() => [
                _createTextVNode("推定一覧")
              ]),
              _: 1
            }),
            _hoisted_3,
            (_ctx.isAdminUser)
              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 0,
                  index: "3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("設定")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_menu_item, { index: "4" }, {
              default: _withCtx(() => [
                _createTextVNode("ログアウト")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onSelect", "default-active"]), [
          [_vShow, _ctx.auth.isAuthenticated]
        ]),
        _createVNode(_component_router_view, { class: "router-view-container" }),
        _createVNode(_component_base_footer)
      ])
    ]),
    _: 1
  }, 8, ["locale"]))
}